import type { ReactNode } from 'react';
import { UiTextProvider } from '@inference.engine/agentic-ui/components';
import { agenticUiText } from './agentic-ui-text';

/** Gives the agentic-ui components inside it this app's copy, outside the builder's own host. */
export function AgenticUiText({ children }: { children: ReactNode }) {
  return <UiTextProvider text={agenticUiText}>{children}</UiTextProvider>;
}
